import { ApiKeyDomain } from './api-key-domain';

export class ApiKeyEndPoint {
	public id: number;
	public apiKeyDomainId: number;
	public method: string;
	public endpoint: string;
	public description: string;
	public isDefault: boolean;

	public domain: ApiKeyDomain;

	constructor(apiKeyEndPoint?: ApiKeyEndPoint) {
		Object.assign(this, apiKeyEndPoint);

		if (apiKeyEndPoint?.domain) {
			this.domain = new ApiKeyDomain(apiKeyEndPoint.domain);
		}
	}
}
